import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FeedbackRow } from '../../feedbacks.abstraction';

@Component({
  selector: 'ca-feedbacks-user-cell',
  standalone: true,
  template: `
    <div>{{ userName() }}</div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class FeedbacksUserCellComponent {
  item = input.required<FeedbackRow>();
  userName = computed(() => `${this.item().botUser.firstName || ''} ${this.item().botUser.lastName || ''}`.trim() || '-');
}
